<!-- Copyright (C) 2023-2025 Skylark Drones -->
<template>
  <h5
    class="text-subtitle-1 font-weight-medium text-uppercase primary-font-color--text"
    data-testid="group-header"
  >
    <slot />
  </h5>
</template>

<script>
export default {
  name: 'GroupHeader'
}
</script>
